import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import Config from "../config.json";
import { Image } from "antd";

// api
import {
  useGetWeedDescriptionQuery,
  useUpdateWeedDescriptionMutation,
} from "api/weedApi";

import {
  useGetPestDescriptionQuery,
  useUpdatePestDescriptionMutation,
} from "api/pestApi";

import {
  useGetDiseaseDescriptionQuery,
  useUpdateDiseaseDescriptionMutation,
} from "api/diseasesApi";

export const openPdfSecurely = (e, file) => {
  e.preventDefault(); // Prevent the default link behavior
  const customHeader = Config.X_API_KEY;
  const pdfUrl = file.url;

  // Make a request with Axios and the custom header
  axios({
    method: "get",
    url: pdfUrl,
    responseType: "blob", // Expect binary response (PDF)
    headers: {
      "X-API-KEY": customHeader,
    },
  })
    .then((response) => {
      // Handle the response, e.g., open the PDF in a new tab
      const url = URL.createObjectURL(
        new Blob([response.data], {
          type: "application/pdf",
        })
      );
      window.open(url, "_self");
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

export const handleImageLoad = (event) => {
  const imgElement = event.target;
  const imageUrl = imgElement.src;

  const headers = {
    "X-API-Key": Config.X_API_KEY,
  };

  const newImage = new Image();
  newImage.src = imageUrl;
  // newImage.onerror = () => handleImageError();
  newImage.onload = () => {
    imgElement.src = imageUrl;
  };
};

export const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};


export const handleAddButtonClick = ({openModalFunction, dispatch}) => {
  dispatch(
    openPestThresholdModal({
      isOpen: true,
    })
  );
};

export const handleUpdateButtonClick = ({dispatch, storeModalDataFunction, data}) =>{
  dispatch(
    storeModalDataFunction({
      componentData: data,
      isOpen: true,
    })
  );
}

export const ImageWithAuth = ({ url, preview }) => {
  const contentStyle = {
    width: "100%",
    height: "250px",
    color: "#fff",
    lineHeight: "160px",
    textAlign: "center",
    background: "#364d79",
    objectFit: "cover",
  };
  const [fetchedImage, setFetchedImage] = useState();
  const [imgUrl, setImgUrl] = useState("");
  const img = React.createRef();

  useEffect(() => {
    axios
      .get(`${url}`, {
        responseType: "arraybuffer",
        headers: {
          "X-API-Key": Config.X_API_KEY,
        },
      })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "image/jpeg",
        });

        const objectURL = URL.createObjectURL(blob);
        setFetchedImage(objectURL);
      });
  }, [url]);

  useEffect(() => {
    // Make sure img.current is not null and image is fetched
    if (img.current && fetchedImage) {
      img.current.src = fetchedImage;
      setImgUrl(fetchedImage);
    }
  }, [fetchedImage]);

  return preview ? (
    <Image
      src={fetchedImage || ""}
      style={contentStyle}
      alt={"Loading..."}
      placeholder={<div style={contentStyle}>Loading...</div>}
    />
  ) : (
    <img src={""} style={contentStyle} alt={"Loading..."} ref={img} />
  );
};

export  const capitalizeText = (text) => {
  return text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

export const getImage = async (imageUrl, imgId) => {
  try {
    const afterSlash = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);
    const imageName = afterSlash.substring(0, afterSlash.lastIndexOf("."));
    const urlObject = new URL(imageUrl);
    const ext = urlObject.pathname.split(".").pop();
    const format =
      ext === "png" ? "png" : ext === "jpg" || ext === "jpeg" ? "jpeg" : "jfif";

    const response = await axios.get(
      `${Config.IPM_SERVER_URL}/api/helper/getImageFile?url=` + imageUrl,
      {
        responseType: "arraybuffer",
        headers: {
          "X-API-Key": Config.X_API_KEY,
        },
      }
    );
    // const response = useGetImageFileQuery(imageUrl);
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });
    const fileUid = uuidv4();
    const file = new File([blob], `${imageName}.${ext}`, {
      type: `image/${format}`,
    });
    const thumbUrl = URL.createObjectURL(file);
    return {
      uid: fileUid,
      originFileObj: file,
      thumbUrl,
      name: imageName,
      imgId: imgId,
      imageUrl: imageUrl,
      status: "done",
    };
  } catch (error) {
    console.error(error);
    return null;
  }
};

export function convertTitleStrToApiTypeFormat(titleStr) {
  return titleStr.replace(/-/g, "").toLowerCase();
}

export function seperateStringJoinedWithDash(titleStr) {
  let str = titleStr?.replace(/-/g, " ").toLowerCase();

  return str?.split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export function joinTextWithDash(str) {
  if (str){
    return str?.replace(/\s+/g, "-").toLowerCase();
  }
  return "";
}

export function setDtoFormData(title, id, type, description = "") {
  const descriptionDto = {
    Id: id,
    Type: convertTitleStrToApiTypeFormat(title),
    Description: description,
  };

  const formDataDto = new FormData();

  formDataDto.append("Id", descriptionDto.Id);
  formDataDto.append("Type", descriptionDto.Type);
  formDataDto.append("Description", descriptionDto.Description);

  return { formDataDto, descriptionDto };
}

export function reloadPage() {
  window.location.reload();
}

export function toCapitalizedFormat(str) {
  return str
    .trim()
    .replace(/\s+/g, " ")
    .replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export const useTypeQuery = (type) => {
  switch (type) {
    case "weed":
      return {
        useGetDescriptionQuery: useGetWeedDescriptionQuery,
        useUpdateDescriptionMutation: useUpdateWeedDescriptionMutation,
      };
    case "pest":
      return {
        useGetDescriptionQuery: useGetPestDescriptionQuery,
        useUpdateDescriptionMutation: useUpdatePestDescriptionMutation,
      };
    case "disease":
      return {
        useGetDescriptionQuery: useGetDiseaseDescriptionQuery,
        useUpdateDescriptionMutation: useUpdateDiseaseDescriptionMutation,
      };
    default:
      throw new Error(`Unsupported type: ${type}`);
  }
};
